module.exports = __webpack_public_path__ + "img/tickets.6410671d.svg";